import React from 'react';
import { useSelectedTheme } from '../../../../../Hooks';

function Divider({ width = '100%' }) {
  const {
    theme: { palette },
  } = useSelectedTheme();
  return (
    <div
      style={{
        height: '1px',
        backgroundColor: palette.border.secondary,
        width: width,
      }}
    />
  );
}

export default Divider;
